module.exports = __webpack_public_path__ + "img/workflow.e66aa8c8.svg";